import listingCancellationPolicyGraphQl from '../api/listingCancellationPolicyGraphQl';
import cancellationPolicyActions from '../actions/cancellationPolicyActions';
import {initialState as cancellationPolicyInitialState} from '../reducers/cancellationPolicyReducer';

async function fetchListingCancellationPolicy(store, action = {payload: {}}) {
    const state = store.getState();
    const {
        listingReducer: {unitApiUrl: unitUrl, listingId},
        systemReducer: {locale}
    } = state;
    const {fieldsChanged, isInitialPageLoad} = action.payload;

    if (!isInitialPageLoad) {
        const data = await listingCancellationPolicyGraphQl({
            ...(fieldsChanged.arriveDateText && {arrivalDate: fieldsChanged.arriveDateText}),
            locale,
            listingId,
            unitUrl
        });

        if (data && data.listing.cancellationPolicy) {
            store.dispatch(
                cancellationPolicyActions.updateCancellationPolicy(data.listing.cancellationPolicy)
            );
        } else {
            store.dispatch(
                cancellationPolicyActions.updateCancellationPolicy(cancellationPolicyInitialState)
            );
        }
    }
}

export default fetchListingCancellationPolicy;
